import { render } from "./Infomacion.vue?vue&type=template&id=4f38fd13&scoped=true"
import script from "./Infomacion.vue?vue&type=script&lang=js"
export * from "./Infomacion.vue?vue&type=script&lang=js"

import "./Infomacion.vue?vue&type=style&index=0&id=4f38fd13&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f38fd13"]])

export default __exports__